import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
interface NavBgGroupProps {
  className?: string;
}
export const NavBgGroup: FC<NavBgGroupProps> = t0 => {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path opacity="0.1" fillRule="evenodd" clipRule="evenodd" d="M0 0C10.012 0 19.1999 5.52348 23.8631 14.3458L35.6642 37.6542C40.3274 46.4765 49.5153 52 59.5275 52H183.472C193.485 52 202.672 46.4765 207.336 37.6542L219.137 14.3458C223.8 5.52348 232.988 0 243 0H0Z" fill="white" />;
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M76.7188 0C89.9282 0 102.05 5.6297 108.203 14.6217L123.772 37.3783C129.925 46.3703 142.047 52 155.257 52H407.181C420.39 52 432.512 46.3703 438.665 37.3783L454.235 14.6217C460.387 5.6297 472.509 0 485.719 0H76.7188Z" fill="#030014" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = <svg width="486" height="52" viewBox="0 0 486 52" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>{t1}{t2}</svg>;
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};